export default {
  pleaseSelectClass: '请选择实体',
  pleaseSelectAttr: '请选择属性',
  createCode: '新增编码',
  editCode: '编辑编码',
  classAttrName: '类别属性名称',
  classAttrCode: '类别属性代码',
  classAttrValue: '类别属性值',
  selectTime: '选择时间',
  selectDate: '选择日期',
  viewCode: '查看编码',
  upload: '上传',
  viewHistoryData: '查看历史数据',
  submit: '提交',
  title: '标题',
  flowType: '流程类型',
  flowStatus: '流程状态',
  pleaseSelectFlowStatus: '请选择流程状态',
  approver: '审批人',
  promoter: '发起人',
  pleaseSelectApprover: '请选择审批人',
  deadLineTime: '截止时间',
  sendTime: '发起时间',
  pleaseSelectTheDeadLineTime: '请选择截止时间',
  createdTime: '创建时间',
  uploader: '上传人',
  cancelTheCode: '是否确定要作废改编码?',
  deleteTheCode: '是否确定要删除该编码?',
  uploadFile: '上传文件',
  pleaseSelectOrEnder: '请先选择或输入第',
  classAttributeValue: '条类别属性值',
  unreleased: '未移交',
  auditing: '审核中',
  canceled: '已作废',
  success: '操作成功',
  pleaseCreateTheNotHandoverObject: '请添加未移交的对象',
  pendingSubmissionPhase: '待提交阶段',
  at: '于',
  launchProcess: '发起流程【编码发布流程】',
  codeApproveProcess: '编码审批流程',
  handoverObject: '审核对象',
  flowApprove: '流程审批',
  codeEdit: '编码编辑',
  codeHistory: '编码历史',
  codeCancel: '编码作废',
  codeDelete: '编码删除',
  codeView: '编码查看',
  handover: '移交',
  handedOver: '已移交',
  joinHandover: '加入移交',
  examine: '审核',
  increase: '添加',
  failed: '未通过',
  passed: '通过',
}
